export default defineNuxtRouteMiddleware(() => {
  const cartStore = useCartStore();
  // Both signals are checked: the cart aggregate is available even when the
  // paginated lines have not been fetched yet, the lines total stays accurate
  // between two cart refreshes
  const isEmpty = (cartStore.cart?.numberOfLines ?? 0) === 0 && cartStore.cartLinesTotal === 0;

  if (isEmpty) {
    return navigateTo('/');
  }
});
